"use client";

import React, { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function TheTrattoriaAtmosphere() {
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      requestAnimationFrame(() => {
        setScrollY(window.scrollY);
      });
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section data-section-id="224086" id="the-wanderlust-philosophy" className="bg-background text-foreground relative overflow-hidden py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-8 items-center">
          
          {}
          <div className="lg:col-span-7 flex flex-col justify-center space-y-8 lg:pr-12 z-20">
            <div className="space-y-4">
              <span className="text-primary font-default text-sm font-semibold tracking-widest uppercase">
                Our Mission
              </span>
              <h2 className="text-4xl md:text-5xl lg:text-7xl font-default font-bold tracking-tight text-foreground leading-tight">
                The Wanderlust Philosophy
              </h2>
            </div>
            
            <div className="space-y-6 text-lg md:text-xl text-muted-foreground font-serif leading-relaxed max-w-2xl">
              <p className="text-foreground italic text-2xl md:text-3xl border-l-4 border-primary pl-6 py-2">
                "Travel is not just about seeing new places, but about seeing with new eyes and discovering the soul of the world."
              </p>
              <p>
                At VOYAGE, we believe that exploration is the ultimate luxury. Our philosophy is rooted in the pursuit of the authentic, the rare, and the transformative. We don't just book trips; we curate life-defining chapters that resonate long after you return home.
              </p>
              <p>
                From the rugged peaks of the Andes to the silent majesty of the Sahara, our mission is to bridge the gap between the curious traveler and the world's most profound wonders through sustainable and immersive storytelling.
              </p>
            </div>
            
            
          </div>

          {}
          <div className="lg:col-span-5 relative h-[500px] lg:h-[700px] w-full mt-12 lg:mt-0 z-10">
            
            {}
            <div className="absolute inset-0 w-full h-full z-10 transition-transform duration-75 ease-out" style={{
            transform: `translateY(${scrollY * 0.03}px)`
          }}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650028/img/voyage_landscape_epic.png" alt="Epic Mountain Landscape" className="w-full h-full object-cover rounded-lg shadow-xl opacity-100" />
              {}
              <div className="absolute inset-0 bg-background/10 rounded-lg"></div>
            </div>

            {}
            <div className="absolute bottom-4 md:bottom-12 -left-4 md:-left-16 w-2/3 aspect-square z-20 transition-transform duration-75 ease-out" style={{
            transform: `translateY(${scrollY * -0.05}px)`
          }}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650028/img/voyage_culture_detail.png" alt="Cultural Immersion Detail" className="w-full h-full object-cover rounded-lg shadow-2xl border-8 border-background" />
            </div>

            {}
            <div className="absolute top-8 md:top-16 -right-4 md:-right-8 w-3/5 aspect-[4/3] z-30 transition-transform duration-75 ease-out" style={{
            transform: `translateY(${scrollY * -0.09}px)`
          }}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650028/img/voyage_luxury_tent.png" alt="Luxury Expedition Base" className="w-full h-full object-cover rounded-lg shadow-2xl border-8 border-background" />
            </div>
            
          </div>
        </div>
      </div>
    </section>;
}